import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { store, accountStore, viewMode, setViewMode, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleReturnToAdmin = () => {
    setViewMode('admin');
    navigate('/admin');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div>
          <h1 className="header-title">🍴 Restaurant.Tools | Stocktake</h1>
          {store && (
            <div className="header-store">
              {store.name}
              {store.role && ` • ${store.role.replace('_', ' ')}`}
            </div>
          )}
        </div>
        <div className="flex gap-2" style={{ alignItems: 'center' }}>
          {accountStore && (accountStore.role === 'app_admin' || accountStore.role === 'business_admin') && viewMode === 'site' && (
            <button className="btn btn-secondary btn-small" onClick={handleReturnToAdmin} style={{ width: 'auto' }}>
              Return to Admin
            </button>
          )}
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
